define( [
	"./arr"
], function( arr ) {

"use strict";

return arr.splice;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/splice.js
// module id = 334
// module chunks = 1